export const JP_PREFECTURES = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "山梨県",
  "長野県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
];

export const JP_CITIES: Record<string, string[]> = {
  北海道: [
    "赤平市",
    "鶴居村",
    "旭川市",
    "芦別市",
    "足寄町",
    "陸別町",
    "厚岸町",
    "浜中町",
    "大空町",
    "津別町",
    "美幌町",
    "網走市",
    "喜茂別町",
    "京極町",
    "倶知安町",
    "豊浦町",
    "洞爺湖町",
    "ニセコ町",
    "真狩村",
    "留寿都村",
    "新篠津村",
    "当別町",
    "石狩市",
    "蘭越町",
    "岩内町",
    "共和町",
    "岩見沢市",
    "壮瞥町",
    "歌志内市",
    "浦河町",
    "雨竜町",
    "秩父別町",
    "沼田町",
    "北竜町",
    "幌加内町",
    "妹背牛町",
    "枝幸町",
    "中頓別町",
    "浜頓別町",
    "恵庭市",
    "江別市",
    "奥尻町",
    "小樽市",
    "帯広市",
    "更別村",
    "中札内村",
    "芽室町",
    "音更町",
    "上士幌町",
    "鹿追町",
    "士幌町",
    "浦臼町",
    "新十津川町",
    "月形町",
    "木古内町",
    "知内町",
    "愛別町",
    "上川町",
    "剣淵町",
    "清水町",
    "下川町",
    "新得町",
    "鷹栖町",
    "当麻町",
    "美瑛町",
    "東神楽町",
    "東川町",
    "比布町",
    "和寒町",
    "七飯町",
    "鹿部町",
    "森町",
    "標茶町",
    "弟子屈町",
    "北広島市",
    "北見市",
    "釧路町",
    "釧路市",
    "せたな町",
    "札幌市",
    "様似町",
    "日高町",
    "平取町",
    "標津町",
    "中標津町",
    "士別市",
    "島牧村",
    "積丹町",
    "清里町",
    "小清水町",
    "斜里町",
    "白老町",
    "白糠町",
    "黒松内町",
    "寿都町",
    "砂川市",
    "今金町",
    "上砂川町",
    "上富良野町",
    "奈井江町",
    "中富良野町",
    "南幌町",
    "南富良野町",
    "猿払村",
    "滝川市",
    "伊達市",
    "千歳市",
    "遠別町",
    "天塩町",
    "豊富町",
    "幌延町",
    "浦幌町",
    "置戸町",
    "訓子府町",
    "佐呂間町",
    "苫小牧市",
    "初山別村",
    "苫前町",
    "羽幌町",
    "池田町",
    "音威子府村",
    "豊頃町",
    "中川町",
    "美深町",
    "本別町",
    "幕別町",
    "名寄市",
    "乙部町",
    "新冠町",
    "根室市",
    "別海町",
    "登別市",
    "函館市",
    "新ひだか町",
    "美唄市",
    "厚沢部町",
    "江差町",
    "上ノ国町",
    "大樹町",
    "広尾町",
    "深川市",
    "八雲町",
    "富良野市",
    "神恵内村",
    "泊村",
    "古平町",
    "北斗市",
    "えりも町",
    "増毛町",
    "福島町",
    "松前町",
    "三笠市",
    "室蘭市",
    "羅臼町",
    "遠軽町",
    "興部町",
    "雄武町",
    "滝上町",
    "西興部村",
    "湧別町",
    "紋別市",
    "長万部町",
    "栗山町",
    "長沼町",
    "由仁町",
    "夕張市",
    "厚真町",
    "安平町",
    "占冠村",
    "むかわ町",
    "赤井川村",
    "仁木町",
    "余市町",
    "利尻町",
    "利尻富士町",
    "小平町",
    "留萌市",
    "礼文町",
    "稚内市",
  ],
  青森県: [
    "青森市",
    "おいらせ町",
    "七戸町",
    "東北町",
    "野辺地町",
    "横浜町",
    "六戸町",
    "六ヶ所村",
    "板柳町",
    "鶴田町",
    "中泊町",
    "黒石市",
    "五所川原市",
    "五戸町",
    "三戸町",
    "新郷村",
    "田子町",
    "南部町",
    "階上町",
    "大間町",
    "風間浦村",
    "佐井村",
    "東通村",
    "つがる市",
    "十和田市",
    "西目屋村",
    "鰺ヶ沢町",
    "深浦町",
    "八戸市",
    "今別町",
    "外ヶ浜町",
    "平内町",
    "蓬田村",
    "平川市",
    "弘前市",
    "三沢市",
    "田舎館村",
    "大鰐町",
    "藤崎町",
    "むつ市",
  ],
  岩手県: [
    "金ケ崎町",
    "一関市",
    "岩手町",
    "葛巻町",
    "雫石町",
    "奥州市",
    "大船渡市",
    "釜石市",
    "大槌町",
    "北上市",
    "久慈市",
    "軽米町",
    "九戸村",
    "野田村",
    "洋野町",
    "住田町",
    "岩泉町",
    "田野畑村",
    "普代村",
    "山田町",
    "紫波町",
    "矢巾町",
    "滝沢市",
    "遠野市",
    "平泉町",
    "一戸町",
    "二戸市",
    "八幡平市",
    "花巻市",
    "宮古市",
    "盛岡市",
    "陸前高田市",
    "西和賀町",
  ],
  宮城県: [
    "丸森町",
    "石巻市",
    "岩沼市",
    "女川町",
    "大崎市",
    "角田市",
    "蔵王町",
    "七ヶ宿町",
    "加美町",
    "色麻町",
    "栗原市",
    "大郷町",
    "大衡村",
    "大和町",
    "気仙沼市",
    "塩竈市",
    "大河原町",
    "川崎町",
    "柴田町",
    "村田町",
    "白石市",
    "仙台市",
    "多賀城市",
    "富谷市",
    "登米市",
    "美里町",
    "涌谷町",
    "名取市",
    "東松島市",
    "七ヶ浜町",
    "松島町",
    "利府町",
    "南三陸町",
    "山元町",
    "亘理町",
  ],
  秋田県: [
    "秋田市",
    "男鹿市",
    "羽後町",
    "東成瀬村",
    "大館市",
    "潟上市",
    "小坂町",
    "鹿角市",
    "上小阿仁村",
    "北秋田市",
    "美郷町",
    "仙北市",
    "大仙市",
    "にかほ市",
    "能代市",
    "井川町",
    "大潟村",
    "五城目町",
    "八郎潟町",
    "八峰町",
    "藤里町",
    "三種町",
    "湯沢市",
    "由利本荘市",
    "横手市",
  ],
  山形県: [
    "遊佐町",
    "尾花沢市",
    "上山市",
    "大石田町",
    "寒河江市",
    "酒田市",
    "新庄市",
    "鶴岡市",
    "天童市",
    "長井市",
    "南陽市",
    "飯豊町",
    "小国町",
    "白鷹町",
    "朝日町",
    "大江町",
    "河北町",
    "西川町",
    "川西町",
    "高畠町",
    "庄内町",
    "三川町",
    "東根市",
    "中山町",
    "山辺町",
    "村山市",
    "大蔵村",
    "金山町",
    "鮭川村",
    "戸沢村",
    "舟形町",
    "真室川町",
    "最上町",
    "山形市",
    "米沢市",
  ],
  福島県: [
    "会津若松市",
    "大玉村",
    "浅川町",
    "石川町",
    "玉川村",
    "平田村",
    "古殿町",
    "いわき市",
    "鏡石町",
    "天栄村",
    "会津美里町",
    "金山町",
    "昭和村",
    "三島町",
    "会津坂下町",
    "柳津町",
    "湯川村",
    "喜多方市",
    "郡山市",
    "白河市",
    "須賀川市",
    "飯舘村",
    "新地町",
    "相馬市",
    "川俣町",
    "国見町",
    "桑折町",
    "伊達市",
    "小野町",
    "三春町",
    "田村市",
    "泉崎村",
    "中島村",
    "西郷村",
    "矢吹町",
    "二本松市",
    "鮫川村",
    "棚倉町",
    "塙町",
    "矢祭町",
    "福島市",
    "大熊町",
    "葛尾村",
    "川内村",
    "富岡町",
    "浪江町",
    "楢葉町",
    "広野町",
    "双葉町",
    "下郷町",
    "只見町",
    "檜枝岐村",
    "南会津町",
    "南相馬市",
    "本宮市",
    "猪苗代町",
    "北塩原村",
    "西会津町",
    "磐梯町",
  ],
  茨城県: [
    "石岡市",
    "潮来市",
    "阿見町",
    "河内町",
    "美浦村",
    "稲敷市",
    "牛久市",
    "小美玉市",
    "笠間市",
    "鹿嶋市",
    "かすみがうら市",
    "神栖市",
    "北茨城市",
    "利根町",
    "大子町",
    "古河市",
    "桜川市",
    "五霞町",
    "境町",
    "下妻市",
    "常総市",
    "高萩市",
    "筑西市",
    "つくば市",
    "つくばみらい市",
    "土浦市",
    "取手市",
    "東海村",
    "那珂市",
    "行方市",
    "坂東市",
    "茨城町",
    "大洗町",
    "城里町",
    "常陸太田市",
    "常陸大宮市",
    "日立市",
    "ひたちなか市",
    "鉾田市",
    "水戸市",
    "守谷市",
    "八千代町",
    "結城市",
    "龍ケ崎市",
  ],
  栃木県: [
    "足利市",
    "宇都宮市",
    "小山市",
    "大田原市",
    "鹿沼市",
    "上三川町",
    "さくら市",
    "佐野市",
    "塩谷町",
    "高根沢町",
    "野木町",
    "壬生町",
    "下野市",
    "栃木市",
    "那須烏山市",
    "那珂川町",
    "那須町",
    "那須塩原市",
    "日光市",
    "市貝町",
    "芳賀町",
    "益子町",
    "茂木町",
    "真岡市",
    "矢板市",
  ],
  群馬県: [
    "草津町",
    "高山村",
    "嬬恋村",
    "中之条町",
    "長野原町",
    "東吾妻町",
    "安中市",
    "伊勢崎市",
    "太田市",
    "板倉町",
    "大泉町",
    "邑楽町",
    "千代田町",
    "明和町",
    "甘楽町",
    "下仁田町",
    "南牧村",
    "榛東村",
    "吉岡町",
    "桐生市",
    "玉村町",
    "渋川市",
    "高崎市",
    "館林市",
    "上野村",
    "神流町",
    "片品村",
    "川場村",
    "昭和村",
    "みなかみ町",
    "富岡市",
    "沼田市",
    "藤岡市",
    "前橋市",
    "みどり市",
  ],
  埼玉県: [
    "上尾市",
    "朝霞市",
    "越生町",
    "三芳町",
    "毛呂山町",
    "入間市",
    "桶川市",
    "寄居町",
    "春日部市",
    "加須市",
    "川口市",
    "川越市",
    "伊奈町",
    "杉戸町",
    "松伏町",
    "北本市",
    "行田市",
    "久喜市",
    "熊谷市",
    "越谷市",
    "神川町",
    "上里町",
    "美里町",
    "鴻巣市",
    "さいたま市",
    "坂戸市",
    "幸手市",
    "狭山市",
    "志木市",
    "白岡市",
    "草加市",
    "小鹿野町",
    "長瀞町",
    "東秩父村",
    "皆野町",
    "横瀬町",
    "秩父市",
    "鶴ヶ島市",
    "所沢市",
    "戸田市",
    "新座市",
    "蓮田市",
    "羽生市",
    "飯能市",
    "東松山市",
    "小川町",
    "川島町",
    "ときがわ町",
    "滑川町",
    "鳩山町",
    "吉見町",
    "嵐山町",
    "日高市",
    "深谷市",
    "富士見市",
    "ふじみ野市",
    "本庄市",
    "三郷市",
    "宮代町",
    "八潮市",
    "吉川市",
    "和光市",
    "蕨市",
  ],
  千葉県: [
    "旭市",
    "我孫子市",
    "鋸南町",
    "御宿町",
    "大多喜町",
    "いすみ市",
    "市川市",
    "市原市",
    "印西市",
    "栄町",
    "酒々井町",
    "浦安市",
    "大網白里市",
    "柏市",
    "勝浦市",
    "神崎町",
    "多古町",
    "東庄町",
    "香取市",
    "鎌ケ谷市",
    "鴨川市",
    "木更津市",
    "君津市",
    "佐倉市",
    "九十九里町",
    "芝山町",
    "横芝光町",
    "山武市",
    "白井市",
    "袖ケ浦市",
    "匝瑳市",
    "館山市",
    "千葉市",
    "銚子市",
    "一宮町",
    "白子町",
    "長生村",
    "長南町",
    "長柄町",
    "睦沢町",
    "富里市",
    "東金市",
    "流山市",
    "習志野市",
    "成田市",
    "野田市",
    "富津市",
    "船橋市",
    "松戸市",
    "南房総市",
    "茂原市",
    "八街市",
    "八千代市",
    "四街道市",
  ],
  東京都: [
    "青ヶ島村",
    "昭島市",
    "あきる野市",
    "足立区",
    "荒川区",
    "板橋区",
    "稲城市",
    "江戸川区",
    "小笠原村",
    "大島町",
    "大田区",
    "青梅市",
    "葛飾区",
    "北区",
    "清瀬市",
    "国立市",
    "小金井市",
    "国分寺市",
    "小平市",
    "狛江市",
    "神津島村",
    "江東区",
    "品川区",
    "渋谷区",
    "新宿区",
    "杉並区",
    "墨田区",
    "世田谷区",
    "台東区",
    "立川市",
    "多摩市",
    "中央区",
    "千代田区",
    "調布市",
    "豊島区",
    "利島村",
    "中野区",
    "奥多摩町",
    "日の出町",
    "檜原村",
    "瑞穂町",
    "西東京市",
    "新島村",
    "練馬区",
    "八王子市",
    "八丈島八丈町",
    "羽村市",
    "東久留米市",
    "東村山市",
    "東大和市",
    "日野市",
    "府中市",
    "福生市",
    "文京区",
    "町田市",
    "御蔵島村",
    "三鷹市",
    "港区",
    "三宅島三宅村",
    "武蔵野市",
    "武蔵村山市",
    "目黒区",
  ],
  神奈川県: [
    "愛川町",
    "清川村",
    "大井町",
    "開成町",
    "中井町",
    "松田町",
    "山北町",
    "箱根町",
    "真鶴町",
    "湯河原町",
    "厚木市",
    "綾瀬市",
    "伊勢原市",
    "海老名市",
    "小田原市",
    "鎌倉市",
    "川崎市",
    "寒川町",
    "相模原市",
    "座間市",
    "逗子市",
    "茅ヶ崎市",
    "大磯町",
    "二宮町",
    "秦野市",
    "平塚市",
    "藤沢市",
    "葉山町",
    "三浦市",
    "南足柄市",
    "大和市",
    "横須賀市",
    "横浜市",
  ],
  新潟県: [
    "阿賀野市",
    "糸魚川市",
    "粟島浦村",
    "関川村",
    "魚沼市",
    "小千谷市",
    "柏崎市",
    "加茂市",
    "刈羽村",
    "聖籠町",
    "五泉市",
    "佐渡市",
    "三条市",
    "出雲崎町",
    "新発田市",
    "上越市",
    "胎内市",
    "燕市",
    "十日町市",
    "津南町",
    "長岡市",
    "弥彦村",
    "新潟市",
    "阿賀町",
    "見附市",
    "湯沢町",
    "南魚沼市",
    "田上町",
    "妙高市",
    "村上市",
  ],
  富山県: [
    "射水市",
    "魚津市",
    "小矢部市",
    "黒部市",
    "朝日町",
    "入善町",
    "高岡市",
    "砺波市",
    "富山市",
    "上市町",
    "立山町",
    "舟橋村",
    "滑川市",
    "南砺市",
    "氷見市",
  ],
  石川県: [
    "加賀市",
    "中能登町",
    "金沢市",
    "内灘町",
    "津幡町",
    "かほく市",
    "小松市",
    "珠洲市",
    "七尾市",
    "野々市市",
    "川北町",
    "能美市",
    "志賀町",
    "宝達志水町",
    "羽咋市",
    "白山市",
    "穴水町",
    "能登町",
    "輪島市",
  ],
  福井県: [
    "あわら市",
    "池田町",
    "越前市",
    "小浜市",
    "おおい町",
    "高浜町",
    "大野市",
    "勝山市",
    "坂井市",
    "鯖江市",
    "敦賀市",
    "南越前町",
    "越前町",
    "福井市",
    "若狭町",
    "美浜町",
    "永平寺町",
  ],
  山梨県: [
    "上野原市",
    "大月市",
    "甲斐市",
    "小菅村",
    "丹波山村",
    "甲州市",
    "甲府市",
    "中央市",
    "都留市",
    "昭和町",
    "市川三郷町",
    "韮崎市",
    "笛吹市",
    "富士吉田市",
    "北杜市",
    "南アルプス市",
    "南部町",
    "早川町",
    "富士川町",
    "身延町",
    "忍野村",
    "道志村",
    "鳴沢村",
    "西桂町",
    "富士河口湖町",
    "山中湖村",
    "山梨市",
  ],
  長野県: [
    "安曇野市",
    "伊那市",
    "飯田市",
    "飯山市",
    "上田市",
    "岡谷市",
    "大町市",
    "飯島町",
    "辰野町",
    "中川村",
    "南箕輪村",
    "箕輪町",
    "宮田村",
    "小布施町",
    "高山村",
    "飯綱町",
    "小川村",
    "信濃町",
    "上松町",
    "大桑村",
    "王滝村",
    "木曽町",
    "木祖村",
    "南木曽町",
    "池田町",
    "小谷村",
    "白馬村",
    "松川村",
    "軽井沢町",
    "立科町",
    "御代田町",
    "駒ヶ根市",
    "小諸市",
    "佐久市",
    "塩尻市",
    "阿智村",
    "阿南町",
    "売木村",
    "大鹿村",
    "下條村",
    "喬木村",
    "高森町",
    "天龍村",
    "豊丘村",
    "根羽村",
    "平谷村",
    "松川町",
    "泰阜村",
    "木島平村",
    "野沢温泉村",
    "山ノ内町",
    "栄村",
    "須坂市",
    "下諏訪町",
    "原村",
    "富士見町",
    "諏訪市",
    "千曲市",
    "茅野市",
    "青木村",
    "長和町",
    "東御市",
    "中野市",
    "長野市",
    "坂城町",
    "朝日村",
    "生坂村",
    "麻績村",
    "筑北村",
    "山形村",
    "松本市",
    "川上村",
    "北相木村",
    "小海町",
    "佐久穂町",
    "南相木村",
    "南牧村",
  ],
  岐阜県: [
    "安八町",
    "神戸町",
    "輪之内町",
    "池田町",
    "揖斐川町",
    "大野町",
    "恵那市",
    "大垣市",
    "白川村",
    "海津市",
    "各務原市",
    "御嵩町",
    "可児市",
    "川辺町",
    "坂祝町",
    "白川町",
    "富加町",
    "東白川村",
    "七宗町",
    "八百津町",
    "岐阜市",
    "郡上市",
    "下呂市",
    "関市",
    "高山市",
    "多治見市",
    "土岐市",
    "中津川市",
    "笠松町",
    "岐南町",
    "羽島市",
    "飛騨市",
    "関ケ原町",
    "垂井町",
    "瑞浪市",
    "瑞穂市",
    "美濃加茂市",
    "美濃市",
    "北方町",
    "本巣市",
    "山県市",
    "養老町",
  ],
  静岡県: [
    "熱海市",
    "伊豆市",
    "伊豆の国市",
    "伊東市",
    "磐田市",
    "御前崎市",
    "掛川市",
    "河津町",
    "西伊豆町",
    "東伊豆町",
    "松崎町",
    "南伊豆町",
    "菊川市",
    "湖西市",
    "御殿場市",
    "静岡市",
    "島田市",
    "下田市",
    "森町",
    "裾野市",
    "小山町",
    "清水町",
    "長泉町",
    "函南町",
    "沼津市",
    "川根本町",
    "吉田町",
    "浜松市",
    "袋井市",
    "藤枝市",
    "富士市",
    "富士宮市",
    "牧之原市",
    "三島市",
    "焼津市",
  ],
  愛知県: [
    "愛西市",
    "東郷町",
    "大治町",
    "蟹江町",
    "飛島村",
    "あま市",
    "安城市",
    "一宮市",
    "稲沢市",
    "犬山市",
    "岩倉市",
    "岡崎市",
    "尾張旭市",
    "大府市",
    "春日井市",
    "蒲郡市",
    "刈谷市",
    "設楽町",
    "豊根村",
    "東栄町",
    "北名古屋市",
    "清須市",
    "小牧市",
    "江南市",
    "新城市",
    "瀬戸市",
    "高浜市",
    "田原市",
    "阿久比町",
    "武豊町",
    "東浦町",
    "南知多町",
    "美浜町",
    "知多市",
    "知立市",
    "津島市",
    "常滑市",
    "豊明市",
    "豊川市",
    "豊田市",
    "豊橋市",
    "東海市",
    "長久手市",
    "名古屋市",
    "西尾市",
    "豊山町",
    "日進市",
    "大口町",
    "扶桑町",
    "幸田町",
    "半田市",
    "碧南市",
    "みよし市",
    "弥富市",
  ],
  三重県: [
    "伊賀市",
    "伊勢市",
    "東員町",
    "いなべ市",
    "尾鷲市",
    "亀山市",
    "紀北町",
    "熊野市",
    "木曽岬町",
    "桑名市",
    "志摩市",
    "鈴鹿市",
    "大台町",
    "多気町",
    "明和町",
    "津市",
    "鳥羽市",
    "名張市",
    "松阪市",
    "朝日町",
    "川越町",
    "菰野町",
    "紀宝町",
    "御浜町",
    "四日市市",
    "大紀町",
    "玉城町",
    "南伊勢町",
    "度会町",
  ],
  滋賀県: [
    "甲良町",
    "多賀町",
    "豊郷町",
    "愛荘町",
    "大津市",
    "近江八幡市",
    "日野町",
    "竜王町",
    "草津市",
    "湖南市",
    "甲賀市",
    "高島市",
    "長浜市",
    "東近江市",
    "彦根市",
    "米原市",
    "守山市",
    "野洲市",
    "栗東市",
  ],
  京都府: [
    "綾部市",
    "宇治市",
    "大山崎町",
    "亀岡市",
    "木津川市",
    "京田辺市",
    "京丹後市",
    "京都市",
    "久御山町",
    "城陽市",
    "笠置町",
    "精華町",
    "南山城村",
    "和束町",
    "井手町",
    "宇治田原町",
    "長岡京市",
    "南丹市",
    "福知山市",
    "京丹波町",
    "舞鶴市",
    "宮津市",
    "向日市",
    "八幡市",
    "伊根町",
    "与謝野町",
  ],
  大阪府: [
    "池田市",
    "泉大津市",
    "泉佐野市",
    "和泉市",
    "茨木市",
    "大阪狭山市",
    "大阪市",
    "貝塚市",
    "柏原市",
    "交野市",
    "門真市",
    "河内長野市",
    "岸和田市",
    "堺市",
    "四條畷市",
    "東大阪市",
    "吹田市",
    "摂津市",
    "熊取町",
    "田尻町",
    "岬町",
    "泉南市",
    "忠岡町",
    "大東市",
    "高石市",
    "高槻市",
    "豊中市",
    "豊能町",
    "能勢町",
    "富田林市",
    "寝屋川市",
    "羽曳野市",
    "阪南市",
    "枚方市",
    "藤井寺市",
    "松原市",
    "島本町",
    "河南町",
    "太子町",
    "千早赤阪村",
    "箕面市",
    "守口市",
    "八尾市",
  ],
  兵庫県: [
    "相生市",
    "明石市",
    "上郡町",
    "赤穂市",
    "朝来市",
    "芦屋市",
    "尼崎市",
    "淡路市",
    "伊丹市",
    "太子町",
    "小野市",
    "加古川市",
    "稲美町",
    "播磨町",
    "加西市",
    "加東市",
    "川西市",
    "猪名川町",
    "市川町",
    "神河町",
    "福崎町",
    "神戸市",
    "佐用町",
    "三田市",
    "宍粟市",
    "洲本市",
    "多可町",
    "高砂市",
    "宝塚市",
    "たつの市",
    "丹波篠山市",
    "丹波市",
    "豊岡市",
    "西宮市",
    "西脇市",
    "姫路市",
    "香美町",
    "新温泉町",
    "三木市",
    "南あわじ市",
    "養父市",
  ],
  奈良県: [
    "安堵町",
    "斑鳩町",
    "三郷町",
    "平群町",
    "生駒市",
    "曽爾村",
    "御杖村",
    "宇陀市",
    "香芝市",
    "橿原市",
    "葛城市",
    "王寺町",
    "河合町",
    "上牧町",
    "広陵町",
    "五條市",
    "御所市",
    "桜井市",
    "川西町",
    "田原本町",
    "三宅町",
    "明日香村",
    "高取町",
    "天理市",
    "奈良市",
    "大和郡山市",
    "大和高田市",
    "山添村",
    "大淀町",
    "上北山村",
    "川上村",
    "黒滝村",
    "下市町",
    "下北山村",
    "天川村",
    "十津川村",
    "野迫川村",
    "東吉野村",
    "吉野町",
  ],
  和歌山県: [
    "有田川町",
    "広川町",
    "湯浅町",
    "有田市",
    "かつらぎ町",
    "九度山町",
    "高野町",
    "岩出市",
    "紀美野町",
    "海南市",
    "紀の川市",
    "御坊市",
    "新宮市",
    "田辺市",
    "上富田町",
    "白浜町",
    "すさみ町",
    "橋本市",
    "北山村",
    "串本町",
    "古座川町",
    "太地町",
    "那智勝浦町",
    "印南町",
    "日高川町",
    "日高町",
    "みなべ町",
    "美浜町",
    "由良町",
    "和歌山市",
  ],
  鳥取県: [
    "岩美町",
    "倉吉市",
    "大山町",
    "南部町",
    "日吉津村",
    "伯耆町",
    "境港市",
    "鳥取市",
    "琴浦町",
    "北栄町",
    "三朝町",
    "湯梨浜町",
    "江府町",
    "日南町",
    "日野町",
    "智頭町",
    "八頭町",
    "若桜町",
    "米子市",
  ],
  島根県: [
    "飯南町",
    "出雲市",
    "雲南市",
    "海士町",
    "隠岐の島町",
    "知夫村",
    "西ノ島町",
    "大田市",
    "邑南町",
    "川本町",
    "美郷町",
    "津和野町",
    "吉賀町",
    "江津市",
    "奥出雲町",
    "浜田市",
    "益田市",
    "松江市",
    "安来市",
  ],
  岡山県: [
    "西粟倉村",
    "赤磐市",
    "里庄町",
    "浅口市",
    "井原市",
    "岡山市",
    "矢掛町",
    "吉備中央町",
    "笠岡市",
    "勝央町",
    "奈義町",
    "久米南町",
    "美咲町",
    "倉敷市",
    "瀬戸内市",
    "総社市",
    "高梁市",
    "玉野市",
    "早島町",
    "津山市",
    "鏡野町",
    "新見市",
    "備前市",
    "新庄村",
    "真庭市",
    "美作市",
    "和気町",
  ],
  広島県: [
    "海田町",
    "熊野町",
    "坂町",
    "府中町",
    "安芸高田市",
    "江田島市",
    "尾道市",
    "大竹市",
    "呉市",
    "庄原市",
    "神石高原町",
    "世羅町",
    "竹原市",
    "大崎上島町",
    "廿日市市",
    "東広島市",
    "広島市",
    "福山市",
    "府中市",
    "三原市",
    "三次市",
    "安芸太田町",
    "北広島町",
  ],
  山口県: [
    "阿武町",
    "岩国市",
    "宇部市",
    "周防大島町",
    "和木町",
    "下松市",
    "上関町",
    "田布施町",
    "平生町",
    "山陽小野田市",
    "下関市",
    "周南市",
    "長門市",
    "萩市",
    "光市",
    "防府市",
    "美祢市",
    "柳井市",
    "山口市",
  ],
  徳島県: [
    "阿南市",
    "阿波市",
    "藍住町",
    "板野町",
    "上板町",
    "北島町",
    "松茂町",
    "海陽町",
    "美波町",
    "牟岐町",
    "勝浦町",
    "上勝町",
    "小松島市",
    "徳島市",
    "那賀町",
    "鳴門市",
    "つるぎ町",
    "美馬市",
    "東みよし町",
    "三好市",
    "石井町",
    "神山町",
    "佐那河内村",
    "吉野川市",
  ],
  香川県: [
    "綾川町",
    "宇多津町",
    "直島町",
    "観音寺市",
    "三木町",
    "坂出市",
    "さぬき市",
    "小豆島町",
    "土庄町",
    "善通寺市",
    "高松市",
    "琴平町",
    "多度津町",
    "まんのう町",
    "東かがわ市",
    "丸亀市",
    "三豊市",
  ],
  愛媛県: [
    "今治市",
    "砥部町",
    "松前町",
    "伊予市",
    "宇和島市",
    "上島町",
    "大洲市",
    "久万高原町",
    "鬼北町",
    "松野町",
    "内子町",
    "西条市",
    "四国中央市",
    "西予市",
    "東温市",
    "伊方町",
    "新居浜市",
    "松山市",
    "愛南町",
    "八幡浜市",
  ],
  高知県: [
    "いの町",
    "仁淀川町",
    "馬路村",
    "北川村",
    "芸西村",
    "田野町",
    "東洋町",
    "奈半利町",
    "安田町",
    "安芸市",
    "香美市",
    "高知市",
    "香南市",
    "四万十市",
    "宿毛市",
    "須崎市",
    "越知町",
    "佐川町",
    "四万十町",
    "津野町",
    "中土佐町",
    "日高村",
    "檮原町",
    "大川村",
    "土佐町",
    "土佐市",
    "土佐清水市",
    "大豊町",
    "本山町",
    "南国市",
    "大月町",
    "黒潮町",
    "三原村",
    "室戸市",
  ],
  福岡県: [
    "筑前町",
    "東峰村",
    "朝倉市",
    "糸島市",
    "飯塚市",
    "うきは市",
    "小郡市",
    "芦屋町",
    "岡垣町",
    "遠賀町",
    "水巻町",
    "大川市",
    "大野城市",
    "大牟田市",
    "春日市",
    "宇美町",
    "粕屋町",
    "篠栗町",
    "志免町",
    "新宮町",
    "須惠町",
    "久山町",
    "桂川町",
    "嘉麻市",
    "北九州市",
    "鞍手町",
    "小竹町",
    "久留米市",
    "古賀市",
    "赤村",
    "糸田町",
    "大任町",
    "川崎町",
    "香春町",
    "添田町",
    "福智町",
    "田川市",
    "太宰府市",
    "筑後市",
    "筑紫野市",
    "上毛町",
    "築上町",
    "吉富町",
    "那珂川市",
    "中間市",
    "直方市",
    "福岡市",
    "福津市",
    "豊前市",
    "大刀洗町",
    "大木町",
    "苅田町",
    "みやこ町",
    "みやま市",
    "宮若市",
    "宗像市",
    "柳川市",
    "広川町",
    "八女市",
    "行橋市",
  ],
  佐賀県: [
    "伊万里市",
    "嬉野市",
    "小城市",
    "鹿島市",
    "唐津市",
    "吉野ヶ里町",
    "神埼市",
    "大町町",
    "江北町",
    "白石町",
    "佐賀市",
    "多久市",
    "武雄市",
    "鳥栖市",
    "有田町",
    "玄海町",
    "太良町",
    "上峰町",
    "基山町",
    "みやき町",
  ],
  長崎県: [
    "壱岐市",
    "諫早市",
    "雲仙市",
    "大村市",
    "小値賀町",
    "佐々町",
    "五島市",
    "西海市",
    "佐世保市",
    "島原市",
    "対馬市",
    "長崎市",
    "時津町",
    "長与町",
    "川棚町",
    "波佐見町",
    "東彼杵町",
    "平戸市",
    "松浦市",
    "南島原市",
    "新上五島町",
  ],
  熊本県: [
    "芦北町",
    "津奈木町",
    "産山村",
    "小国町",
    "高森町",
    "西原村",
    "南阿蘇村",
    "南小国町",
    "阿蘇市",
    "苓北町",
    "天草市",
    "荒尾市",
    "宇城市",
    "宇土市",
    "上天草市",
    "嘉島町",
    "甲佐町",
    "益城町",
    "御船町",
    "山都町",
    "大津町",
    "菊陽町",
    "菊池市",
    "あさぎり町",
    "五木村",
    "球磨村",
    "相良村",
    "多良木町",
    "錦町",
    "水上村",
    "山江村",
    "湯前町",
    "熊本市",
    "合志市",
    "美里町",
    "玉東町",
    "長洲町",
    "和水町",
    "南関町",
    "玉名市",
    "人吉市",
    "水俣市",
    "氷川町",
    "八代市",
    "山鹿市",
  ],
  大分県: [
    "宇佐市",
    "臼杵市",
    "大分市",
    "杵築市",
    "玖珠町",
    "九重町",
    "国東市",
    "佐伯市",
    "竹田市",
    "津久見市",
    "中津市",
    "日出町",
    "姫島村",
    "日田市",
    "豊後大野市",
    "豊後高田市",
    "別府市",
    "由布市",
  ],
  宮崎県: [
    "えびの市",
    "三股町",
    "串間市",
    "小林市",
    "川南町",
    "木城町",
    "新富町",
    "高鍋町",
    "都農町",
    "西米良村",
    "西都市",
    "五ヶ瀬町",
    "高千穂町",
    "日之影町",
    "高原町",
    "日南市",
    "延岡市",
    "門川町",
    "椎葉村",
    "美郷町",
    "諸塚村",
    "綾町",
    "国富町",
    "日向市",
    "都城市",
    "宮崎市",
  ],
  鹿児島県: [
    "湧水町",
    "姶良市",
    "阿久根市",
    "奄美市",
    "伊佐市",
    "長島町",
    "出水市",
    "いちき串木野市",
    "指宿市",
    "天城町",
    "伊仙町",
    "宇検村",
    "喜界町",
    "瀬戸内町",
    "龍郷町",
    "知名町",
    "徳之島町",
    "大和村",
    "与論町",
    "和泊町",
    "十島村",
    "三島村",
    "鹿児島市",
    "鹿屋市",
    "肝付町",
    "錦江町",
    "東串良町",
    "南大隅町",
    "霧島市",
    "中種子町",
    "南種子町",
    "屋久島町",
    "さつま町",
    "薩摩川内市",
    "志布志市",
    "大崎町",
    "曽於市",
    "垂水市",
    "西之表市",
    "日置市",
    "枕崎市",
    "南九州市",
    "南さつま市",
  ],
  沖縄県: [
    "石垣市",
    "糸満市",
    "浦添市",
    "うるま市",
    "沖縄市",
    "宜野湾市",
    "伊江村",
    "恩納村",
    "大宜味村",
    "宜野座村",
    "金武町",
    "国頭村",
    "今帰仁村",
    "東村",
    "本部町",
    "粟国村",
    "伊是名村",
    "伊平屋村",
    "北大東村",
    "久米島町",
    "座間味村",
    "渡嘉敷村",
    "渡名喜村",
    "南風原町",
    "南大東村",
    "八重瀬町",
    "与那原町",
    "豊見城市",
    "嘉手納町",
    "北中城村",
    "北谷町",
    "中城村",
    "西原町",
    "読谷村",
    "名護市",
    "那覇市",
    "南城市",
    "多良間村",
    "宮古島市",
    "竹富町",
    "与那国町",
  ],
};
